
/* @params field : HTMLInputElement */

const validateField = (field: any) => {
    const verifyErrors = () => {
        
        let foundError: boolean | string = false;

        for (const error in field.validity) {
            if (field.validity[error] && !field.validity.valid) {
                foundError = error;
            }
        }

        return foundError;
    }

    return function () {

        const error = verifyErrors();

        if (error) {
            field.classList.add("invalid");
        } else {
            field.classList.remove("invalid");
        }
    };

}


export {validateField};